import axios from 'axios';
import { HistoryStatsQueryParams, HistoryStatsResponse } from '../models/HistoricalStats';
import { ITableMatchItem } from '../models/Match';
// const origin = globalThis?.window?.location?.origin || 'https://localhost:3000';

// const baseUrl = `/api/matches`;

interface GetListParams {
  count: number;
  offset: number;
  sortType: any;
  search: string;
  // mockType: FlashScoreDataType;
  mockType: string;
}

export interface StatsQueryParams {
  statName: string;
  // sortDirection?: "asc" | "desc";
  sortDirection?: string;
  date: string;
  count?: number;
  offset?: number;
  // sortType?: "avg" | "home" | "mutual" | "away";
  sortType?: string;
}

type GetAllResponse = {
  count: number;
  data: any;
};
export const MatchesService = {
  getAll: (params: { date: string; search?: string }) => {
    return axios.get<GetAllResponse>('/api/stats/all-matches', { params }).then(({ data }) => {
      return {
        count: data.count,
        data: data.data,
      };
    });
  },
  getSpecificStat: (params: StatsQueryParams) => {
    return axios.get<{ countAll: number; data: ITableMatchItem[] }>('/api/stats', { params }).then(({ data }) => {
      return {
        count: data.countAll,
        data: data.data,
      };
    });

    // .catch((err) => {
    //   console.error("Something went wrong in getSpecificStat: ", err);
    // });
  },
  getStatHistory: (params: HistoryStatsQueryParams) => {
    return axios.get<HistoryStatsResponse>('/api/stats/history', { params }).then(({ data }) => {
      return {
        count: data.count,
        data: data.data,
        statInfo: data.statInfo,
      };
    });
  },
  getMatch: async (id: number | null) => {
    if (!id) return {};
    const params = { id };
    return axios.get(`/api/stats/${id}`, { params }).then((res) => res.data);
  },
};
